import {
  FETCH_TRANSACTIONS_HISTORY_REQUEST,
  FETCH_TRANSACTIONS_HISTORY_SUCCESS,
  FETCH_TRANSACTIONS_HISTORY_FAILURE,
} from "./actionTypes";

export const fetchTransactionsHistoryRequest = () => ({
  type: FETCH_TRANSACTIONS_HISTORY_REQUEST,
});

export const fetchTransactionsHistorySuccess = (transactions) => ({
  type: FETCH_TRANSACTIONS_HISTORY_SUCCESS,
  payload: transactions,
});

export const fetchTransactionsHistoryFailure = (error) => ({
  type: FETCH_TRANSACTIONS_HISTORY_FAILURE,
  payload: error,
});


